import type { Vector } from './vector';

export interface HitArea {
  contains: (x: number, y: number) => boolean;
}

export function moveHitArea(hitArea: HitArea, moveBy: Vector): HitArea {
  return {
    contains: (x, y) => hitArea.contains(x - moveBy.x, y - moveBy.y),
  };
}

export const mergeHitAreas = (...hitAreas: HitArea[]): HitArea => ({
  contains: (x, y) => hitAreas.some((hitArea) => hitArea.contains(x, y)),
});
